export const DEFAULTPATH = '/home/page'
window.DEFAULTPATH = DEFAULTPATH
export function getDefaultData() {
  return DEFAULTPATH
}
